import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'voice-message',
    templateUrl: './voice-message.component.html'
})
export class VoiceMessageComponent {

    @Input() readonly messages: any;
    @Input() readonly uuid: string;

    hasRecordings: boolean = undefined;

    constructor(public sanitizer: DomSanitizer) {
    }

    messagesHasRecordings(): boolean {
        if (this.hasRecordings !== undefined) {
            return this.hasRecordings;
        }

        for (const message of this.messages) {
            if (message.deviceId.includes('pnova')) {
                this.hasRecordings = true;

                return true;
            }
        }

        this.hasRecordings = false;

        return false;
    }

    getDownloadLink(messageUuid, messagePartId): any {
        // the download link will not work in local for chrome, as the link to mp3 is backend instead of localhost

        return this.sanitizer.bypassSecurityTrustResourceUrl(`servlets/audio/messagedata/uuid/${messageUuid}/${messagePartId}/download/`);
    }

    play(uuid, partId, audioService): any {
        this.messages.forEach(message => {
            if (message.audioService !== undefined) {
                if (message.audioService.getAudio() !== undefined) {
                    message.audioService.getAudio()
                        .pause();
                }
            }
        });

        const audio: HTMLAudioElement = new Audio();
        audio.src = `servlets/audio/messagedata/uuid/${uuid}/${partId}/play/`;
        audioService.setAudio(audio);
        audioService.playAudio();
    }

    stop(audioService): any {
        audioService.stopAudio();
    }

    getAnsweredByText(answerBy: string): string {
        let answerByText;
        answerByText =
            answerBy.indexOf('unknown') !== -1 ? 'Unable to determine if human or machine' :
                answerBy === '' ? '' :
                    ( answerBy.indexOf('human') !== -1 ? 'Human' : 'Machine');

        return answerByText;
    }
}
